import styled from "styled-components";

export const Begin = styled.div`
    font-family: Inter;
    padding: 125px;
    display: flex;
`;

export const BeginLeft = styled.div`
    float: left;
    width: 60%;
    display: inherit;
    flex-direction: column;
    justify-content: center;
`;

export const BeginRight = styled.div`
    float: left;
    width: 40%;
`;

export const Title = styled.h1`
    font-weight: 600;
    font-size: 36px;
`;

export const Subitle = styled.h1`
    font-weight: 600;
    font-size: 24px;
`;

export const Word = styled.p`
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
`;

export const Image = styled.img`
    display: block;
    margin-left: auto;
    margin-right: 0;
    width: 70%;
`;

export const LightBg = styled.div`
    font-family: Inter;
    padding: 75px 125px;
    background: #FFFFFF;
`;

export const PurpleBg = styled.div`
    font-family: Inter;
    padding: 75px 125px;
    background: #6554C0;
    color: #FFFFFF;
`;

export const ParentCard = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    margin-top: 50px;
    margin-bottom: 50px;
    gap: 1rem;
`;

export const LCard = styled.div`
    display: flex;
    box-sizing: border-box;
    background: #FFFFFF;
    color: #000000;
    text-align: left;
    width: 300px;
    height: 100%;
    border-radius: 10px;
    padding: 20px;
    flex-direction: column;
    cursor: pointer;
`;

  